import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import MyProjectDetailsCard from './MyProjectDetailsCard'
import MyProjectStepsSection from './MyProjectStepsSection'
import MyProjectOpisSection from './MyProjectOpisSection'
import MyProjectProofFilesSection from './MyProjectProofFilesSection'
import useMyProjectDetailsPage from './hooks/useMyProjectDetailsPage'

export default function MyProjectDetails() {
	const { t } = useTranslation()
	const {
		project,
		loading,
		statusLabel,
		createdDate,
		mySteps,
		uploadProjectFile,
		downloadProjectFile,
		deleteProjectFile,
	} = useMyProjectDetailsPage()

	if (loading) {
		return <LoadingIndicator message={t('myProjects.details.loading', { defaultValue: 'Ładowanie projektu...' })} />
	}

	if (!project) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				{t('myProjects.details.noData', { defaultValue: 'Nie znaleziono projektu.' })}
			</div>
		)
	}

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			<MyProjectDetailsCard
				project={project}
				statusLabel={statusLabel}
				createdDate={createdDate}
			/>

			<MyProjectStepsSection steps={mySteps} />

			<MyProjectOpisSection opis={project.opis} />

			<MyProjectProofFilesSection
				project={project}
				onUploadProjectFile={uploadProjectFile}
				onDownloadProjectFile={downloadProjectFile}
				onDeleteProjectFile={deleteProjectFile}
			/>
		</div>
	)
}
